(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-pdp-danh-gia-khoi"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rb-review-list')) {
    class RbReviewList extends HTMLElement {
      /* ═══════════════════════════════════════════════════════════════════════════════════
         VÁ 23/08/2026 — KHỐI ĐÁNH GIÁ ĐANG KHOÁ LUỒNG CHÍNH TRÊN ĐIỆN THOẠI

         BỆNH (đo được, không phải suy đoán). Bản cũ làm ba việc, mỗi việc là một cái bẫy:
         · `resizeObserver.observe(card)` cho TỪNG thẻ — hammock có 40 thẻ, toàn store 227.
         · `refresh()` xen kẽ GHI rồi ĐỌC trên từng thẻ: remove('is-collapsible') →
           add('is-collapsible') → đọc `text.scrollHeight`. Mỗi lần đọc ngay sau khi ghi là
           một lần ÉP TÍNH LẠI BỐ CỤC ĐỒNG BỘ của cả tài liệu cao ~8.500 px, nhân 40 thẻ.
         · thay đổi kích thước do chính `refresh()` gây ra lại đánh thức observer ⇒ chạy lại.

         SỐ ĐO (roambark.com/products/dog-car-seat-hammock, 390×844 DPR3, CPU ×4, mạng 4G,
         cache NGUỘI, Emulation.setFocusEmulationEnabled BẬT — 3 lượt yên máy):
             TBT      13.955 / 11.473 / 14.268 ms  →  2.056 / 1.720 / 2.004 ms   (−86%)
             tác vụ dài nhất  6.142 / 5.103 / 6.582 ms  →  492 / 283 / 529 ms     (−92%)
             pixel Meta PageView  20.028 / 16.659 / 19.763 ms  →  6.951 / 6.794 / 6.989 ms
         Bản vá còn ngang với phép thử "gỡ hẳn khối" (TBT 2.370 ms) — tức phần đắt đã hết.
         LCP không đổi (1,2–1,4 s cả hai bên): trang VẼ xong sớm rồi mới chết cứng, đúng lúc
         khách từ Reels chạm Add to cart. Nút là <form method="post"> nên cú chạm không mất,
         nhưng khách không thấy phản hồi nào trong 6 giây.

         ⚠️ CHỈ CẮN TRÊN ĐIỆN THOẠI: `enabled` đòi matchMedia('(max-width: 749px)'). Đo trên
         desktop 1440 ra TBT ~2.000 ms ở CẢ hai bên — nghĩa là mọi lượt kiểm bằng desktop sẽ
         báo SẠCH vĩnh viễn. Ai nghiệm thu phải đo ở 390×844.

         BA THAY ĐỔI, ĐỪNG ĐẢO LẠI CÁI NÀO:
         (1) Quan sát MỘT phần tử bao ngoài (this) thay vì 40 thẻ, và CHỈ phản ứng khi CHIỀU
             RỘNG đổi. Chiều rộng mới là thứ quyết định chữ xuống mấy dòng; chiều cao đổi là do
             chính refresh() gây ra, phản ứng với nó là tự cắn đuôi.
         (2) Tách ĐỌC khỏi GHI: ghi hết class → đọc hết scrollHeight vào mảng → rồi mới ghi
             nút. Một lần ép tính lại bố cục thay vì 40 lần. ĐÂY LÀ THỨ THẬT SỰ CHỮA BỆNH.
         (3) Dồn mọi lời gọi vào MỘT requestAnimationFrame (cờ `dangCho`) nên nhiều nguồn
             kích hoạt cùng lúc chỉ tốn một lượt.

         HAI CHỖ PHẢI GIỮ, BỎ LÀ HỎNG CHỨC NĂNG (đã tái hiện được cả hai):
         · Nghe sự kiện 'toggle' của <details> ở pha CAPTURE. 37/40 đánh giá nằm trong
           "Show more reviews ↓"; mở nó chỉ đổi CHIỀU CAO nên observer theo chiều rộng không
           bắt được, và sự kiện 'toggle' KHÔNG nổi bọt nên phải bắt ở pha capture.
         · Uỷ quyền sự kiện click trên chính `this` thay vì gắn 40 listener trong
           connectedCallback. Bản cũ gắn listener ngay lúc nâng cấp phần tử; nếu ngày nào
           scripts.js được nạp sớm hơn (defer/module trong <head>) thì lúc đó CON CHƯA ĐƯỢC
           PHÂN TÍCH XONG, querySelectorAll trả 0 nút, và nút "Read more" chết lặng không báo
           lỗi. Đã dựng lại đúng cảnh đó và thấy nút mất tác dụng hoàn toàn.

         NGHIỆM THU CHỨC NĂNG (4 mốc, bản vá phải khớp bản cũ từng mốc — đã chạy, khớp 4/4):
         mở <details> → 40/40 thẻ có is-collapsible · kéo dài một đánh giá cho tràn 8 dòng →
         nút hiện, nhãn "Read more" · bấm → is-expanded, nhãn "Read less", aria-expanded=true,
         clientHeight 192→600 · bấm lại → thu về 192, nhãn "Read more".
         ═══════════════════════════════════════════════════════════════════════════════════ */
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.beRong = -1;
        this.dangCho = false;

        /* Uỷ quyền click — xem ghi chú (3) ở trên. Rẻ hơn 40 listener VÀ sống sót được nếu
           phần tử bị nâng cấp trước khi con của nó phân tích xong. */
        this.addEventListener('click', (e) => {
          const nut = e.target?.closest?.('.rbp-dg__doc-them');
          if (!nut) return;
          const card = nut.closest('.rbp-dg__i');
          if (card) this.toggle(card);
        }, { signal: signal });

        /* 'toggle' của <details> KHÔNG nổi bọt → phải capture. Bỏ dòng này thì 37 đánh giá
           trong "Show more reviews" không bao giờ được tính lại. */
        this.addEventListener('toggle', () => this.henRefresh(), { signal: signal, capture: true });

        /* MỘT observer trên phần tử bao ngoài, và chỉ quan tâm CHIỀU RỘNG. */
        this.resizeObserver = new ResizeObserver(() => {
          const rong = Math.round(this.clientWidth);
          if (rong === this.beRong) return;
          this.beRong = rong;
          this.henRefresh();
        });
        this.resizeObserver.observe(this);

        this.henRefresh();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.henRefresh(), { signal: signal, once: true });
        }
        /* Font đổi sau khi tải xong làm chữ dài/ngắn đi — tính lại đúng một lần, không cần
           observer nào cho việc này. */
        document.fonts?.ready?.then(() => this.henRefresh());
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.khungHinh) cancelAnimationFrame(this.khungHinh);
      }

      /* Gom mọi yêu cầu tính lại vào ĐÚNG MỘT khung hình. Nhiều nguồn (observer, details,
         font, DOMContentLoaded) có thể bắn cùng lúc — không có cờ này thì mỗi nguồn một lượt. */
      henRefresh() {
        if (this.dangCho) return;
        this.dangCho = true;
        this.khungHinh = requestAnimationFrame(() => {
          this.dangCho = false;
          this.refresh();
        });
      }

      refresh() {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const enabled = this.dataset.collapseMobile === 'true' && mobile;

        const the = [];
        this.querySelectorAll('.rbp-dg__i').forEach((card) => {
          const text = card.querySelector('.rbp-dg__noi');
          const button = card.querySelector('.rbp-dg__doc-them');
          if (text && button) the.push({ text: text, button: button, mo: text.classList.contains('is-expanded') });
        });

        if (!enabled) {
          for (const t of the) {
            t.text.classList.remove('is-collapsible');
            t.button.hidden = true;
          }
          return;
        }

        /* ĐỢT GHI 1 — chỉ đặt class, không đọc gì. */
        for (const t of the) t.text.classList.add('is-collapsible');

        /* ĐỢT ĐỌC — gom hết vào mảng. Lời đọc ĐẦU TIÊN ép tính lại bố cục một lần; những lời
           sau miễn phí vì ở giữa không có lời ghi nào. Xen kẽ đọc-ghi ở đây là quay lại đúng
           cái bệnh 13.955 ms. */
        for (const t of the) t.tran = t.mo || t.text.scrollHeight > t.text.clientHeight + 2;

        /* ĐỢT GHI 2 — không đọc kích thước nữa. */
        for (const t of the) {
          t.button.hidden = !t.tran;
          t.button.textContent = t.mo ? this.dataset.lessLabel : this.dataset.moreLabel;
        }
      }

      toggle(card) {
        const text = card.querySelector('.rbp-dg__noi');
        const button = card.querySelector('.rbp-dg__doc-them');
        if (!text || !button) return;

        const expanded = text.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
        if (!expanded) this.henRefresh();
      }
    }
    customElements.define('rb-review-list', RbReviewList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-pdp-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rb-ugc-carousel')) {
    customElements.define('rb-ugc-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.viewport = this.querySelector('.rb-ugc__viewport');
        this.track = this.querySelector('.rb-ugc__track');
        this.originalSlides = [...this.querySelectorAll('[data-rb-ugc-slide]')];
        if (!this.viewport || !this.track || this.originalSlides.length < 2) return;

        const cloneBefore = this.originalSlides[this.originalSlides.length - 1].cloneNode(true);
        const cloneAfter = this.originalSlides[0].cloneNode(true);
        for (const clone of [cloneBefore, cloneAfter]) {
          clone.dataset.rbUgcClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('aria-label');
        }
        this.track.prepend(cloneBefore);
        this.track.append(cloneAfter);

        this.slides = [...this.track.children];
        this.index = 1;
        this.translate = 0;
        this.dragging = false;
        this.hovered = false;
        this.inView = true;
        this.lastWheelAt = 0;
        this.delay = Number(this.dataset.autoplayDelay) || 2500;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onResize = () => requestAnimationFrame(() => this.goTo(this.index, false));
        this.onVisibility = () => document.hidden ? this.stopAutoplay() : this.scheduleAutoplay();
        this.onTransitionEnd = (event) => {
          if (event.propertyName !== 'transform') return;
          if (this.index === 0) this.goTo(this.originalSlides.length, false);
          if (this.index === this.slides.length - 1) this.goTo(1, false);
        };

        this.bindInteraction();
        this.track.addEventListener('transitionend', this.onTransitionEnd);
        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0]?.isIntersecting ?? true;
            this.inView ? this.scheduleAutoplay() : this.stopAutoplay();
          }, { threshold: 0.2 });
          this.observer.observe(this);
        }

        requestAnimationFrame(() => {
          this.goTo(this.index, false);
          this.dataset.ready = 'true';
          this.scheduleAutoplay();
        });
      }

      disconnectedCallback() {
        this.stopAutoplay();
        clearTimeout(this.resumeTimer);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      bindInteraction() {
        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.scheduleAutoplay();
        });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.interact(event.key === 'ArrowRight' ? 1 : -1);
        });

        this.viewport.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) < 14 || Math.abs(event.deltaX) <= Math.abs(event.deltaY) * 1.25) return;
          event.preventDefault();
          const now = Date.now();
          if (now - this.lastWheelAt < 520) return;
          this.lastWheelAt = now;
          this.interact(event.deltaX > 0 ? 1 : -1);
        }, { passive: false });

        this.viewport.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          this.dragging = true;
          this.startX = event.clientX;
          this.startTranslate = this.translate;
          this.dataset.dragging = 'true';
          this.stopAutoplay();
          this.viewport.setPointerCapture(event.pointerId);
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.dragging || !event.isPrimary) return;
          const delta = event.clientX - this.startX;
          if (Math.abs(delta) > 4 && event.cancelable) event.preventDefault();
          this.setTranslate(this.startTranslate + delta);
        });

        const finishDrag = (event) => {
          if (!this.dragging) return;
          this.dragging = false;
          delete this.dataset.dragging;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          const delta = event.clientX - this.startX;
          const threshold = Math.min(72, this.slides[this.index].offsetWidth * 0.18);
          if (delta < -threshold) this.goBy(1);
          else if (delta > threshold) this.goBy(-1);
          else this.goTo(this.index);
          this.resumeAfterInteraction();
        };

        this.viewport.addEventListener('pointerup', finishDrag);
        this.viewport.addEventListener('pointercancel', finishDrag);
      }

      interact(direction) {
        this.stopAutoplay();
        this.goBy(direction);
        this.resumeAfterInteraction();
      }

      goBy(direction) {
        this.goTo(this.index + direction);
      }

      goTo(nextIndex, animate = true) {
        this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
        const slide = this.slides[this.index];
        if (!slide) return;
        if (!animate) this.track.style.transition = 'none';
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        this.setTranslate((this.viewport.clientWidth / 2) - slideCenter);
        this.updateEmphasis();
        if (!animate) {
          this.track.getBoundingClientRect();
          this.track.style.removeProperty('transition');
        }
      }

      setTranslate(value) {
        this.translate = value;
        this.track.style.transform = `translate3d(${value}px, 0, 0)`;
      }

      updateEmphasis() {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-neighbor', Math.abs(slideIndex - this.index) === 1);
          if (slide.dataset.rbUgcClone === 'true') return;
          active ? slide.setAttribute('aria-current', 'true') : slide.removeAttribute('aria-current');
        });
      }

      stopAutoplay() {
        clearTimeout(this.autoplayTimer);
      }

      scheduleAutoplay() {
        this.stopAutoplay();
        if (this.reducedMotion || this.hovered || this.dragging || !this.inView || document.hidden) return;
        this.autoplayTimer = setTimeout(() => {
          this.goBy(1);
          this.scheduleAutoplay();
        }, this.delay);
      }

      resumeAfterInteraction() {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => this.scheduleAutoplay(), 3600);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbh-daianh"] && !Shopify.designMode) return;
  try {
    
  /* Thẻ tuỳ chỉnh <rbh-dai-anh>: chọn kiểu này để Theme Editor thêm/bớt/kéo thả section là
     connectedCallback tự chạy lại — không phải nghe shopify:section:load rồi tự dò lại DOM.

     BA CHỖ ĐÃ TRẢ GIÁ, ĐỪNG "TỐI GIẢN" LẠI:
     · scrollBy KHÔNG truyền behavior ⇒ trình duyệt đọc `scroll-behavior` của CSS ⇒ @media
       (prefers-reduced-motion: reduce) mới tắt được thật. Gõ thẳng 'smooth' ở đây là đè lên
       lựa chọn của người dùng ngay tại chỗ vừa tôn trọng nó trong stylesheet.
     · Bước cuộn = khoảng cách giữa HAI Ô ĐẦU, không cộng tay `width + gap`: khe đổi theo ba
       breakpoint, cộng tay là chép con số ở chỗ thứ hai rồi có ngày lệch.
     · Đo tràn bằng ResizeObserver chứ không window.resize: bề rộng ô khai bằng vw nên nó đổi cả
       khi thanh cuộn dọc của trang xuất hiện — lúc đó window.resize KHÔNG bắn.
     Nới 1px khi so mép (scrollLeft > 1, < con - 1): scrollLeft là số thực, ở mép hay ra 0.5. */
  (function () {
    var LOP_AN = 'rbh-daianh__cum--an';

    class RbhDaiAnh extends HTMLElement {
      connectedCallback() {
        this.cuon = this.querySelector('.rbh-daianh__cuon');
        if (!this.cuon) return;

        this.cum = this.querySelector('.rbh-daianh__cum');
        this.nutTruoc = this.querySelector('[data-rbh-huong="truoc"]');
        this.nutSau = this.querySelector('[data-rbh-huong="sau"]');

        this.doLai = this.doLai.bind(this);
        this.bamTruoc = () => this.day(-1);
        this.bamSau = () => this.day(1);

        this.cuon.addEventListener('scroll', this.doLai, { passive: true });
        if (this.nutTruoc) this.nutTruoc.addEventListener('click', this.bamTruoc);
        if (this.nutSau) this.nutSau.addEventListener('click', this.bamSau);

        if ('ResizeObserver' in window) {
          this.theoDoi = new ResizeObserver(this.doLai);
          this.theoDoi.observe(this.cuon);
          var hang = this.querySelector('.rbh-daianh__hang');
          if (hang) this.theoDoi.observe(hang);
        } else {
          window.addEventListener('resize', this.doLai);
        }

        this.doLai();
      }

      disconnectedCallback() {
        if (this.theoDoi) this.theoDoi.disconnect();
        if (this.cuon) this.cuon.removeEventListener('scroll', this.doLai);
        if (this.nutTruoc) this.nutTruoc.removeEventListener('click', this.bamTruoc);
        if (this.nutSau) this.nutSau.removeEventListener('click', this.bamSau);
        window.removeEventListener('resize', this.doLai);
      }

      buoc() {
        var cac = this.querySelectorAll('.rbh-daianh__o');
        if (cac.length >= 2) return cac[1].offsetLeft - cac[0].offsetLeft;
        if (cac.length === 1) return cac[0].offsetWidth;
        return this.cuon.clientWidth;
      }

      day(huong) {
        this.cuon.scrollBy({ left: this.buoc() * huong });
      }

      doLai() {
        var con = this.cuon.scrollWidth - this.cuon.clientWidth;
        var tran = con > 1;
        if (this.cum) this.cum.classList.toggle(LOP_AN, !tran);
        if (this.nutTruoc) this.nutTruoc.disabled = !tran || this.cuon.scrollLeft <= 1;
        if (this.nutSau) this.nutSau.disabled = !tran || this.cuon.scrollLeft >= con - 1;
      }
    }

    if (!customElements.get('rbh-dai-anh')) customElements.define('rbh-dai-anh', RbhDaiAnh);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbh-header"] && !Shopify.designMode) return;
  try {
    
  // NÂNG CẤP DẦN. <details>/<summary> đã đóng mở được không cần một dòng JS nào — gỡ hết khối này
  // đi thì header vẫn điều hướng được. Ở đây chỉ thêm ba tiện ích, và mỗi cái đều tự bảo vệ.
  (function () {
    var CHON = '.rbh-search[open], .rbh-drawer[open]';

    function dongHet(tru) {
      var mo = document.querySelectorAll(CHON);
      for (var i = 0; i < mo.length; i++) {
        if (mo[i] !== tru) mo[i].removeAttribute('open');
      }
    }

    // 1. Bấm ra ngoài thì đóng.
    document.addEventListener('click', function (su) {
      var mo = document.querySelectorAll(CHON);
      for (var i = 0; i < mo.length; i++) {
        if (!mo[i].contains(su.target)) mo[i].removeAttribute('open');
      }
    });

    // 2. Esc thì đóng và trả tiêu điểm về nút vừa mở — nếu không, tiêu điểm rơi về đầu trang.
    document.addEventListener('keydown', function (su) {
      if (su.key !== 'Escape') return;
      var mo = document.querySelectorAll(CHON);
      for (var i = 0; i < mo.length; i++) {
        var nut = mo[i].querySelector('summary');
        mo[i].removeAttribute('open');
        if (nut) nut.focus();
      }
    });

    // 3. Mở cái này thì đóng cái kia, và tự đặt con trỏ vào ô tìm kiếm.
    // `toggle` KHÔNG nổi bọt ⇒ phải bắt ở pha capture, không phải pha bubble.
    document.addEventListener(
      'toggle',
      function (su) {
        var d = su.target;
        if (!d || !d.matches || !d.matches('.rbh-search, .rbh-drawer') || !d.open) return;
        dongHet(d);
        var o = d.querySelector('.rbh-search__o');
        if (o) o.focus();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
